import React, { Component } from 'react'
import DefaultLayout from '../../Layout/Default'
import Box from '../../../Shared/Box'
import { Col, Container, Row } from '../../../Shared/Grid'
import './styles.scss'
import Loader from '../../../Shared/Loader'
import { withTranslation } from 'react-i18next'
import dayjs from 'dayjs'
import Button from '../../../Shared/Form/Button'
import { adminGetSubscription, adminGetSubscriptionItems, patchSubscription } from '../../../../api'
import Select from '../../../Shared/Form/Select'
import OrderHistory from './history'
import DatePicker from '../../../Shared/DatePicker'
import Invoices from './invoices'
import OrderComments from './Comments'
import OrderItems from './Items'
import get from 'lodash.get'

class OrderPage extends Component {

  constructor (props) {
    super(props)

    this.state = {
      order: null,
      orderItems: {},
      loadingOrder: false,
      loadingPatchOrder: false,
      loadingItems: false,
    }
  }

  componentDidMount () {
    this.getOrder(this.props.match.params.id)
    this.loadSubscriptionItems(this.props.match.params.id)
  }

  onInputChange (event, name) {
    let state = {}
    state[name] = event.target.value
    this.setState(state)
  }

  onStatusChange (event, statusKey) {
    let status = parseInt(event.target.value, 10)
    this.setState({ loadingPatchOrder: true }, () => {
      let patch = {}
      patch[statusKey] = status
      patchSubscription(this.state.order.id, patch).fetchPromise.then((response) => {
        this.setState({ order: response, loadingPatchOrder: false })
      }).catch(() => {
        this.setState({ loadingPatchOrder: false })
      })
    })
  }

  onCancellationDateChange = (date) => {
    let key = 'cancellationDate'
    this.setState({ loadingPatchOrder: true }, () => {
      let patch = {}
      if (date === null) {
        patch[key] = null
      } else {
        patch[key] = dayjs(date).format('YYYY-MM-DD')
      }
      patchSubscription(this.state.order.id, patch).fetchPromise.then((response) => {
        this.setState({ order: response, loadingPatchOrder: false })
      }).catch(() => {
        this.setState({ loadingPatchOrder: false })
      })
    })
  }

  getWorkflowStatusOptions () {
    const { t } = this.props
    return [
      { label: t('ORDER_WORKFLOW_STATUS_UNPROCESSED'), value: 0 },
      { label: t('ORDER_WORKFLOW_STATUS_PROCESSED'), value: 1 },
    ]
  }

  getBillingStatusOptions () {
    const { t } = this.props
    return [
      { label: t('STATUS_INACTIVE'), value: 0 },
      { label: t('STATUS_ACTIVE'), value: 1 },
    ]
  }

  getPaymentStatusOptions () {
    const { t } = this.props
    return [
      { label: t('STATUS_INACTIVE'), value: 0 },
      { label: t('STATUS_ACTIVE'), value: 1 },
    ]
  }

  getOrder (id) {
    this.setState({ loadingOrder: true }, () => {
      adminGetSubscription(id).fetchPromise.then((response) => {
        this.setState({ order: response, loadingOrder: false })
      }).catch(() => {
        this.setState({ loadingOrder: false })
      })
    })
  }

  loadSubscriptionItems (id) {
    this.setState({ loadingItems: true }, () => {
      adminGetSubscriptionItems(id).fetchPromise.then((response) => {
        let items = {}
        response.forEach((item) => {
          items[item.id] = item
        })
        this.setState({ orderItems: items, loadingItems: false })
      }).catch(() => {
        this.setState({ loadingItems: false })
      })
    })
  }

  onCustomerEdit = () => {
    this.props.history.push('/admin/orders/' + this.state.order.id + '/customer')
  }

  render () {
    const { t } = this.props

    return (
      <DefaultLayout>
        <div className="orderPage">
          <Box style={{ position: 'relative' }} hasInnerBackground={true}>
            {this.state.order && this.state.loadingItems === false ?
              <Container fluid gutterWidth={5}>
                {this.state.loadingPatchOrder ? <Loader size={32}/> : null}
                <Row>
                  <Col xs={12}>
                    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                      <h3>{t('ORDER')} {this.state.order.id}</h3>
                      <span><strong>{t('ORDER_DATE')}</strong>: {this.state.order.createdAt ? dayjs(this.state.order.createdAt).locale(this.props.i18n.language).format('L LT') : '-'}</span>
                    </div>
                    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                      <div>{t('PROMOTION_CODE')}: {get(this.state.order, 'salesToken.token', '-')}</div>
                      <div>{this.state.order.modifiedAt ? dayjs(this.state.order.modifiedAt).locale(this.props.i18n.language).format('L LT') : '-'}, {this.state.order.userCode}</div>
                    </div>
                  </Col>
                </Row>
                <Row style={{ justifyContent: 'space-between' }}>
                  <Col xs={12} sm={6} md={5} lg={4}>
                    <div className="flex-table" style={{ flex: 1 }}>
                      <div style={{ position: 'relative' }}>
                        <table className="table table-hover table-mc-light-blue Gradient">
                          <thead>
                          <tr>
                            <td colSpan={2}>{t('CUSTOMER')} <Button align={'right'}
                                                                    style={{ padding: '3px 10px' }}
                                                                    onClick={this.onCustomerEdit}>Edit</Button></td>
                          </tr>
                          </thead>
                          <tbody>
                          <tr>
                            <td>{t('COMPANY')}</td>
                            <td>{this.state.order.customer.company}</td>
                          </tr>
                          <tr>
                            <td>{t('LEGAL_FORM')}</td>
                            <td>{this.state.order.customer.legalForm}</td>
                          </tr>
                          <tr>
                            <td>{t('FIRST_NAME')}</td>
                            <td>{this.state.order.customer.firstname}</td>
                          </tr>
                          <tr>
                            <td>{t('LAST_NAME')}</td>
                            <td>{this.state.order.customer.lastname}</td>
                          </tr>
                          <tr>
                            <td>{t('STREET_STREET_NUMBER')}</td>
                            <td>{this.state.order.customer.street}</td>
                          </tr>
                          <tr>
                            <td>{t('CITY')}</td>
                            <td>{this.state.order.customer.city}</td>
                          </tr>
                          <tr>
                            <td>{t('STATE')}</td>
                            <td>{this.state.order.customer.state}</td>
                          </tr>
                          <tr>
                            <td>{t('COUNTRY')}</td>
                            <td>{this.state.order.customer.countryCode}</td>
                          </tr>
                          <tr>
                            <td>{t('EMAIL')}</td>
                            <td>{this.state.order.customer.email}</td>
                          </tr>
                          <tr>
                            <td>{t('URL')}</td>
                            <td>{this.state.order.customer.url}</td>
                          </tr>
                          <tr>
                            <td>{t('PHONE')}</td>
                            <td>{this.state.order.customer.phone}</td>
                          </tr>
                          <tr>
                            <td>{t('FAX')}</td>
                            <td>{this.state.order.customer.fax}</td>
                          </tr>
                          <tr>
                            <td>{t('VAT_ID')}</td>
                            <td>{this.state.order.customer.vatId}</td>
                          </tr>
                          <tr>
                            <td>{t('WINLINE_ID')}</td>
                            <td>{this.state.order.customer.winlineId}</td>
                          </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </Col>
                  <Col xs={12} sm={12} md={5} lg={3}>
                    <div style={{ marginBottom: '5px' }}>
                      <Select onChange={(e) => {this.onStatusChange(e, 'workflowStatus')}}
                              options={this.getWorkflowStatusOptions()}
                              selected={this.state.order.workflowStatus} label={'Status'}/>
                    </div>
                    <div style={{ marginBottom: '5px' }}>
                      <Select onChange={(e) => {this.onStatusChange(e, 'billingStatus')}}
                              options={this.getBillingStatusOptions()}
                              selected={this.state.order.billingStatus} label={t('BILLING_STATUS')}/>
                    </div>
                    <div style={{ marginBottom: '5px' }}>
                      <Select options={this.getPaymentStatusOptions()}
                              onChange={() => {}}
                              disabled={true} selected={this.state.order.paymentStatus} label={t('PAYMENT_STATUS')}/>
                    </div>
                    <div style={{ marginBottom: '5px' }}>
                      <label>{t('CANCELLATION_DATE')}</label>
                      <DatePicker
                        selected={this.state.order.cancellationDate === null ? null : new Date(this.state.order.cancellationDate)}
                        onChange={this.onCancellationDateChange}/>
                    </div>
                  </Col>
                </Row>
                <Row>
                  <Col xs={12}>
                    <h3>{t('ITEMS')}</h3>
                  </Col>
                  <Col xs={12}>
                    <OrderItems orderItems={this.state.orderItems ? Object.values(this.state.orderItems) : []}/>
                  </Col>
                </Row>
                <Invoices orderId={this.state.order.id}
                          orderItems={this.state.orderItems ? this.state.orderItems : {}}/>
                <OrderComments orderId={this.state.order.id}/>
                <OrderHistory id={this.state.order.id} refreshIndicator={this.state.order}/>
                <Row>
                  <Col xs={6}>
                    <Button onClick={() => {
                      this.props.history.push('/admin/orders')
                    }}>{t('BACK_TO_ORDERS')}</Button>
                  </Col>
                </Row>
              </Container>
              : <Loader size={32}/>}
          </Box>
        </div>
      </DefaultLayout>
    )
  }
}

export default withTranslation()(OrderPage)
